import styled from 'styled-components'
export const StyledSection = styled.div`
  div,
  span,
  p,
  a,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: ${props => props.theme.textAppearances[props.text].fontSize};
    font-family: ${props => props.theme.textAppearances[props.text].fontFamily};
    line-height: ${props => props.theme.textAppearances[props.text].lineHeight};
  }

  p {
    margin-bottom: 10px;
  }

  .additional-text {
    max-height: 0;
    transition: max-height 0.5s ease, margin-top 0.2s ease 0.3s,
      margin-bottom 0.2s ease 0.3s;
    overflow: hidden;
    margin: 0;

    p {
      font-size: ${props => props.theme.textAppearances.copy150.fontSize};
      font-family: ${props => props.theme.textAppearances.copy150.fontFamily};
      line-height: ${props => props.theme.textAppearances.copy150.lineHeight};
    }

    &--show {
      transition: max-height 1.5s ease, margin-top 0.2s ease,
        margin-bottom 0.2s ease;
      max-height: 200px;
      margin-top: 10px;
      margin-bottom: 0;
    }
  }

  button {
    border: none;
    background: transparent;
    margin: 0;
    display: inline-block;
    outline: none;
    cursor: pointer;
    vertical-align: middle;
    margin: -10px 0 0 8px;
    padding: 10px 0 0;

    > svg {
      fill: #001e50;
    }
  }
`
